// 1. Импорты Swiper и модулей
import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from 'swiper/modules';

// 2. Импорты стилей Swiper
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../../styles/swiper.css';

// 3. Инициализация (когда DOM готов)
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.student-life-slider');

  sliders.forEach((slider) => {
    new Swiper(slider, {
      modules: [Navigation, Pagination, Autoplay],

      loop: true,
      centeredSlides: true, // Активный слайд всегда по центру
      slidesPerView: 'auto', // Ширина слайда берется из CSS (важно!)
      spaceBetween: 16, // Отступ между слайдами (px)

      // Автоплей
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },

      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },

      // Брейкпоинты для тонкой настройки отступов
      breakpoints: {
        // Мобилка: почти на всю ширину, соседний чуть выглядывает
        320: {
          spaceBetween: 16,
        },
        // Десктоп: отступы побольше
        1024: {
          spaceBetween: 32,
        },
      },
    });
  });
});
